import { render, staticRenderFns } from "./Jyly.vue?vue&type=template&id=0fbf5c6e&scoped=true"
import script from "./Jyly.vue?vue&type=script&lang=js"
export * from "./Jyly.vue?vue&type=script&lang=js"
import style0 from "./Jyly.vue?vue&type=style&index=0&id=0fbf5c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf5c6e",
  null
  
)

export default component.exports